import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Bell } from "lucide-react";

const SPECIALTIES = [
    "Musculation",
    "Running",
    "CrossFit",
    "Boxe",
    "Yoga",
    "Prep Physique",
    "Gestion du stress",
    "Confiance en soi",
    "Anti-Burnout",
    "Motivation",
    "Sortir de la solitude",
];

export default function AlertForm() {
    const [email, setEmail] = useState("");
    const [city, setCity] = useState("");
    const [specialty, setSpecialty] = useState("");
    const [sending, setSending] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setSending(true);
        try {
            await api.post("/alerts", {
                email,
                city: city || null,
                specialty: specialty || null,
            });
            toast.success("Alerte activée", {
                description:
                    "On te prévient dès qu'un nouveau coach vérifié correspond à tes critères.",
            });
            setEmail("");
            setCity("");
            setSpecialty("");
        } catch {
            toast.error("Impossible d'enregistrer l'alerte. Réessaie.");
        } finally {
            setSending(false);
        }
    };

    return (
        <section className="border-y border-white/10 bg-[#0f0f0f]">
            <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-6 py-16 lg:grid-cols-5">
                <div className="lg:col-span-2">
                    <div className="inline-flex items-center gap-2 border border-white/10 px-3 py-1.5">
                        <Bell className="h-3 w-3 text-[#FF2E2E]" />
                        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-400">
                            Alerte nouveau coach
                        </span>
                    </div>
                    <h2 className="mt-4 font-display text-4xl uppercase leading-none tracking-tight text-white sm:text-5xl">
                        Sois alerté·e en premier
                    </h2>
                    <p className="mt-4 max-w-md text-sm uppercase tracking-widest text-neutral-400">
                        Un e-mail — zéro spam, zéro liste de diffusion, zéro reciblage.
                        Juste la notification quand un nouveau coach vérifié rejoint ta
                        ville ou ta discipline.
                    </p>
                </div>

                <form
                    data-testid="alert-form"
                    onSubmit={submit}
                    className="lg:col-span-3 grid grid-cols-1 gap-3 border border-white/10 bg-[#121212] p-6 md:grid-cols-2"
                >
                    <div className="md:col-span-2">
                        <Label className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">
                            E-mail
                        </Label>
                        <Input
                            data-testid="alert-email"
                            type="email"
                            required
                            placeholder="toi@domaine.fr"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-2 h-11 rounded-none border-white/10 bg-[#0a0a0a] text-white"
                        />
                    </div>
                    <div>
                        <Label className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">
                            Ville (optionnel)
                        </Label>
                        <Input
                            data-testid="alert-city"
                            placeholder="Paris, Lyon..."
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            className="mt-2 h-11 rounded-none border-white/10 bg-[#0a0a0a] text-white"
                        />
                    </div>
                    <div>
                        <Label className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">
                            Discipline (optionnel)
                        </Label>
                        <select
                            data-testid="alert-specialty"
                            value={specialty}
                            onChange={(e) => setSpecialty(e.target.value)}
                            className="mt-2 h-11 w-full rounded-none border border-white/10 bg-[#0a0a0a] px-3 text-sm text-white focus:border-[#FF2E2E] focus:outline-none"
                        >
                            <option value="">Toutes</option>
                            {SPECIALTIES.map((s) => (
                                <option key={s} value={s}>
                                    {s}
                                </option>
                            ))}
                        </select>
                    </div>
                    <Button
                        data-testid="alert-submit"
                        disabled={sending}
                        className="md:col-span-2 h-12 rounded-none bg-[#FF2E2E] font-display text-lg uppercase tracking-tight text-white hover:bg-[#D61F1F]"
                    >
                        {sending ? "Enregistrement..." : "Activer l'alerte"}
                    </Button>
                </form>
            </div>
        </section>
    );
}
